import { Navigate } from 'react-router';
import { isFeatureEnabled } from '../../config/features.js';
import { useUiStore } from '../../core/stores/uiStore.js';

/**
 * @param {{ feature: string, children: import('react').ReactNode }} props
 */
export function FeatureRoute({ feature, children }) {
  const addToast = useUiStore((s) => s.addToast);

  if (!isFeatureEnabled(feature)) {
    addToast({ type: 'info', message: 'This feature is not available in your app version.' });
    return <Navigate to="/" replace />;
  }

  return children;
}
